// This file was auto-generated by Fern from our API Definition.
export const TriggerAuthScheme = {
    Oauth: "oauth",
    ApiKey: "api_key",
};
